<template>
  <v-select v-model="data" :items="items" label="Role"></v-select>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      items: [
        'SALES REPRESENTATIVE',
        'DEVELOPER',
        'MANAGER',
        'ACCOUNTANT',
        'RECEPTIONIST'
      ],
      data: ''
    }
  },
  created() {
    if (this.value) {
      this.data = this.value
    }
  },
  watch: {
    data: function(value) {
      this.$emit('input', value)
    },
    value: function(value) {
      this.data = value
    }
  }
}
</script>

<style></style>
